// AI-CONTEXT: See docs/features/afspraak-soort-en-aanwezigheid-bkb.md
// De voorgestelde duur van een nieuw huisbezoek. Geen apart veld 'tijdsbehoefte'
// op het huishouden: de klussen (subtaken) hebben al 'Geschatte minuten', en
// de nog in te plannen klussen van dat huishouden zijn precies wat er in het
// bezoek moet gebeuren (Gijs, 2026-10-06).

/** Zoals de agenda altijd al deed bij slepen en bij één klik. */
const DEFAULT_VISIT_MINUTES = 60

/**
 * @param {Array<{EstimateMinutes?: *}>|undefined} unplannedSubtasks - Uitkomst van `unplannedSubtasksFor`
 * @returns {number} De som van de bruikbare schattingen, of 60 als er geen zijn
 */
const visitDurationMinutes = (unplannedSubtasks) => {
    const som = (Array.isArray(unplannedSubtasks) ? unplannedSubtasks : [])
        .map((t) => Number(t && t.EstimateMinutes))
        .filter((m) => Number.isFinite(m) && m > 0)
        .reduce((acc, m) => acc + m, 0)
    return som > 0 ? som : DEFAULT_VISIT_MINUTES
}

/**
 * @param {Date} start
 * @param {number} minutes
 * @returns {Date}
 */
const visitEndFor = (start, minutes) => new Date(start.getTime() + minutes * 60 * 1000)

export { DEFAULT_VISIT_MINUTES, visitEndFor }
export default visitDurationMinutes
